/**
 * Turbo Drive can replace the entire <body>, which can drop in-page Chameleon UI.
 * Move likely Chameleon nodes from the current body into the incoming `newBody`
 * on `turbo:before-render` (before Turbo applies the swap).
 *
 * Enable on <html> via: data-chameleon-turbo-preserve="true" (set in base.html; prod/qa only).
 */
export function preserveChameleonNodes(nextBody) {
  if (!nextBody || !document.body) {
    return;
  }

  const selectors = [
    '[id^="chmln"]',
    '[class*="chmln"]',
    'iframe[src*="chameleon"]',
    'iframe[src*="trychameleon"]',
  ].join(", ");

  const nodes = document.body.querySelectorAll(selectors);
  const topLevelNodes = Array.from(nodes).filter((node) => {
    const parent = node.parentElement;
    // If a matching ancestor exists starting at the parent, this node is nested
    // in another Chameleon container and will move with that container.
    return !parent || !parent.closest(selectors);
  });

  topLevelNodes.forEach((node) => {
    nextBody.appendChild(node);
  });
}

export function installChameleonTurboPreserve() {
  if (window.__chameleonTurboPreserveInstalled) {
    return;
  }

  if (document.documentElement.dataset.chameleonTurboPreserve !== "true") {
    return;
  }

  window.__chameleonTurboPreserveInstalled = true;

  document.addEventListener("turbo:before-render", (event) => {
    const nextBody = event?.detail?.newBody || null;
    preserveChameleonNodes(nextBody);
  });
}
